import React from "react";
import Landing from "./components/landing/Landing";
import Footer from "common/components/Footer/Footer";
import Header from "common/components/Header/Header";
import { Box, Flex, Button } from "@chakra-ui/react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import LandingForm from "./components/landing/Form";
function PublicPage() {
  const location = useLocation();
  console.log("location", location.pathname);
  return (
    <Flex w="100%" justifyContent="center">
      <Flex
        mx="auto"
        justifyContent="center"
        mb="30px"
        mt="50px"
        // pt={{ sm: "100px", md: "0px" }}
        // borderRadius="1rem"
        direction="row-reverse"
        //bgColor="white"
        width={{ base: "90%", md: "unset" }}
      >
        <Routes>
          <Route path="/form" element={<LandingForm />} />
          <Route path="/" element={<Landing />} />
        </Routes>
      </Flex>
      {/* <Routes>
        <Route path="/" element={<Landing />} />
      </Routes> */}
    </Flex>
  );
}

export default PublicPage;
